module.exports = __webpack_public_path__ + "static/media/jumpseller-configure.6a3b630f.png";